import { render, staticRenderFns } from "./checkbox.component.vue?vue&type=template&id=6db8f130&scoped=true"
import script from "./checkbox.component.vue?vue&type=script&lang=ts"
export * from "./checkbox.component.vue?vue&type=script&lang=ts"
import style0 from "./checkbox.component.vue?vue&type=style&index=0&id=6db8f130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8f130",
  null
  
)

export default component.exports